module.exports = __webpack_public_path__ + "images/admin/multiple-pipelines-blue.gif";